<crm-single-select
  optionValue="name"
  [options]="modes"
  [(selectedItem)]="selectedMode"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  (selectedItemChange)="selectedModeChange.emit($event)"
  [isTemplateCombined]="true"
  [filter]="false"
  [showClear]="showClear"
  [disabled]="disabled"
  [appendTo]="appendTo"
  filterBy="name">
  <ng-template
    #itemTemplate
    let-priority="item">
    {{ priority?.value | barrierOpenModeName }}
  </ng-template>
</crm-single-select>
